export default "__VITE_ASSET__B0a5dKy$__"